

import { defineComponent, onMounted, ref, onBeforeUnmount, onUnmounted,computed } from 'vue';
import { MessageService } from '../../../../../../../common/infrastructure/servicios';
import { MessageType } from '../../../../../../../common/infrastructure/servicios/MessageService';
import { IapComponentDataSource } from '../../../../../component/domain/iapComponentDataSource';
import ComponentCommon from '../../../../domain/Functions/ComponentCommon';
import { Container } from 'inversify';
import AutocompleteTypeConst from '../../../../domain/Constants/AutocompleteTypeConst';
import ControlTypeConst from '../../../../domain/Constants/ControlTypeConst';
import WidgetComponentDataTree from '../../../../../designer/domain/widgetComponent';
import { IapComponentAttribute } from '../../../../../component/domain/iapComponentAttribute';
import CustomValidate from '../../shared/CustomValidate.vue';
import { useStore } from 'vuex';	

export default defineComponent({
    name: 'dynamic_autocomplete',
    components: {
        CustomValidate
    },
    props:
    {
        container: {
            type: Object as () => Container
        },
        Component: {
            type: Object as () => WidgetComponentDataTree,
            default: () => ({})
        },
        rootParentId:
        {
            type: Number,
            default: (-1)
        },
        dataSources: {
            type: Object as () => IapComponentDataSource[],
            default: () => ({})
        },
        slotProps: {
            type: Object,
            default: () => ({})
        },
        rootParentAttr: {
            type: Object as () => IapComponentAttribute[],
            default: () => ({})
        },
    },
    setup(props, context) {
        //
        
        const store = useStore();
        const data = ref();
        const selectedData = ref();
        const filteredData = ref();
        const fieldSearch = ref('');
        const { vmodel, getPropertyValue, getPropertyBooleanValue, getCatalogValue, getPropertyNumberValue, loaded, componentData, resolveExpressions, baseOnMounted, baseOnBeforeUnmount, baseOnUnmount, v$, submitted, canEdit, isValidData
            , fieldKey, fieldKeyComponentDataSourceId, getComponentDataSourceItemsFromId, getOptionLabelAutocomplete
        } = ComponentCommon(props, context,store);


        
        const getInputStyle = computed(() => {

            let inputStyleObj:any={};
            
            if(getPropertyBooleanValue(AutocompleteTypeConst.READONLY) ){
                inputStyleObj.readonly=true;
            }
            
            return inputStyleObj;
        })

        const clickf = ref(new Function());

        const showMessage = (msg: string) => {
            MessageService.showToast(MessageType.Correcto, '', msg)
        }


        const search = (event: any) => {

            setTimeout(() => {
                if (!event.query.trim().length) {
                    filteredData.value = [...data.value];
                } else {
                    if (data.value) {
                        filteredData.value = data.value.filter((x: any) => {
                            if (fieldSearch.value) {
                                return x[fieldSearch.value].toLowerCase().startsWith(event.query.toLowerCase());
                            }

                        });
                    }

                }
            }, 250);
        }

        //const functions = ref([]);
        onMounted(() => {

            data.value = getComponentDataSourceItemsFromId(AutocompleteTypeConst.SUGGESTIONS);
            fieldSearch.value = getOptionLabelAutocomplete();

        })

        onUnmounted(() => {
            baseOnUnmount();
        })

        return {
            clickf,
            MessageService,
            MessageType,
            showMessage,
            getPropertyValue,
            getPropertyBooleanValue,
            vmodel,
            AutocompleteTypeConst,
            loaded,
            v$,
            submitted,
            canEdit,
            isValidData,
            fieldKey,
            fieldKeyComponentDataSourceId,
            getPropertyNumberValue,
            getCatalogValue,
            filteredData,
            search,
            fieldSearch,
            ControlTypeConst,
            getInputStyle
        };
    },
});
